import React from 'react';
import DocumentosVersionadosPage from "../../components/documentos/DocumentosVersionadosPage";
import AdicionarTermos from "./components/AdicionarTermos";

function TermosDeUso() {
    return (
        <DocumentosVersionadosPage
            title="Termos de Uso"
            subtitle="Histórico de versões dos termos de uso apresentados aos clientes."
            listEndpoint="listarTermos"
            responseKey="termos"
            getId={(termo) => termo?.idTermo}
            addLabel="Nova versão"
            emptyMessage="Nenhum termo de uso cadastrado."
            renderAddDialog={({ open, onClose }) => (
                <AdicionarTermos adicionarTermos={open} setAdicionarTermos={(value) => !value && onClose()} />
            )}
        />
    );
}

export default TermosDeUso;
